export default __webpack_public_path__ + "static/media/GearSix.9448c854.svg";